import React from 'react'
import { observer, Provider } from 'mobx-react'
import { Calendar,  Input, Popover, TimePicker } from 'antd'
import { Controller } from './Controller'
import { CalendarCell } from './CalendarCell'
import { CalendarHeader } from './CalendarHeader'
import { translateKey as t } from '../../locales/translation'


import './DateRangePicker.scss'

import _ from 'lodash'
import dayjs, { Dayjs } from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

@observer
export class DateRangePicker extends React.Component<{
  // Function to be used to pass selected days to the parent components
  onSelection: (dates: Array<Dayjs>) => void

  // This value used to be able to reset the selected days from outside this component, like the table filters
  values?: Array<Dayjs>

  // Pass moment dates which will indicate available range to select the dates from
  availableRange?: { from: Dayjs; to: Dayjs }
  // Pass moment dates which will be available to select while the rest of them will be blocked
  availableDates?: Array<Dayjs>
  singleSelect?: boolean
  showTimePicker?: {
    show: boolean
    toISOString?: boolean
  }
  valueFormat?: string

  // How many days can the user select within the range
  availableSelectedRange?: number
  defaultValue?: Dayjs
  disabled?: boolean // Disable whole date picker
  inDropDown?: {
    show: boolean // Show the date picker in a drop down
    placeholder?: string
    allowClear?: boolean
    size?: 'small' | 'middle' | 'large'
  }
}> {
  private controller = new Controller(this.props)

  public componentDidUpdate() {
    if (this.props.values !== undefined) {
      if (Array.isArray(this.props.values)) {
        this.controller.selectedDates = this.props.values
      } else if (this.props.values) {
        this.controller.selectedDates = [this.props.values]
      } else {
        this.controller.selectedDates = []
      }
    }
  }

  private renderInputValues = () => {
    const values = []

    this.props.values.forEach((sd: any) => {
      if (sd) {
        values.push(sd.format(this.props.valueFormat ? this.props.valueFormat : 'YYYY-MM-DD'))
      }
    })

    return values.join(', ')
  }

  private renderCalendar = () => {
    const { inDropDown } = this.props

    if (inDropDown?.show) {
      return (
        <Popover
          placement='bottom'
          onOpenChange={(value) => (this.controller.showDropDown = value)}
          open={this.controller.showDropDown}
          content={
            <div style={{ margin: '-12px -16px' }}>
              <Calendar
                headerRender={({ onChange }) => <CalendarHeader onChange={onChange} disabled={this.props.disabled} />}
                dateFullCellRender={(date) => (
                  <CalendarCell
                    date={date}
                    availableRange={this.props.availableRange}
                    singleSelect={this.props.singleSelect}
                    availableDates={this.props.availableDates}
                    availableSelectedRange={this.props.availableSelectedRange}
                    disabled={this.props.disabled}
                  />
                )}
                onSelect={(date) => (this.controller.calendarsDate = date)}
                fullscreen={false}
              />
            </div>
          }
          trigger='click'
        >
          <Input
            placeholder={inDropDown.placeholder ? inDropDown.placeholder : t('lblSelectTheDate', 'Select The Date')}
            size={inDropDown?.size || 'small'}
            value={this.renderInputValues()}
            allowClear={inDropDown?.allowClear || false}
            suffix={<FontAwesomeIcon icon={faCalendar}/>}
            onChange={(e) => {
              if (!e.target.value) {
                this.controller.selectedDates = []
                this.controller.onSelection([])
              }
            }}
          />
        </Popover>
      )
    }

    return (
      <Calendar
        headerRender={({ onChange }) => <CalendarHeader onChange={onChange} disabled={this.props.disabled} />}
        dateFullCellRender={(date) => (
          <CalendarCell
            date={date}
            availableRange={this.props.availableRange}
            singleSelect={this.props.singleSelect}
            availableDates={this.props.availableDates}
            availableSelectedRange={this.props.availableSelectedRange}
            disabled={this.props.disabled}
          />
        )}
        onSelect={(date) => (this.controller.calendarsDate = date)}
        fullscreen={false}
      />
    )
  }

  public render() {
    return <Provider controller={this.controller}>{this.renderCalendar()}</Provider>
  }
}
